import {State} from "./types";

export const initialState: State = {
  redirect: undefined,
};
